export let StoreController = {
  getStoreInformationPopupContent: function (id, infoContainer) {
    if (infoContainer) {
      jQuery.ajax({
        url: mb_plugin_globalvars.ajaxurl,
        type: "POST",
        data: {
          action: "ajax_get_single_store_infos",
          storeId: id,
        },
        beforeSend: function () {
          infoContainer.innerHTML = "";
          infoContainer.classList.add("mb-loading");
          infoContainer.classList.add("active");
        },
        success: function (response) {
          //do something on success
          infoContainer.classList.remove("mb-loading");
          infoContainer.innerHTML = response.data;
        },
        error: function (xhr) {
          //do something on error
          console.log("Error", xhr.responseText);
        },
      });
    }
  },
};
